/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 * The datasource purpose and for which use-cases it is needed. - INPUT_OUTPUT: Is used as source of raw data and predictions/metadata within .lightly as well as destination for writing thumbnails, crops or video frame within .lightly - INPUT: Is only used as source of raw data - LIGHTLY: Is used as source of predictions/metadata within .lightly as well as destination for writing thumbnails, crops or video frames within .lightly
 * @export
 * @enum {string}
 */
export enum DatasourcePurpose {
    INPUT_OUTPUT = 'INPUT_OUTPUT',
    INPUT = 'INPUT',
    LIGHTLY = 'LIGHTLY'
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const DatasourcePurposeValidatorShape = [
    'INPUT_OUTPUT',
    'INPUT',
    'LIGHTLY'
];
export const DatasourcePurposeValidator = yup.mixed().oneOf(DatasourcePurposeValidatorShape);
export const DatasourcePurposeStringifyShapeProperties = {};
export const DatasourcePurposeStringifyShape: StringSchema = {
    title: 'DatasourcePurpose Stringifier',
    type: 'string'
};
export const DatasourcePurposeStringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DatasourcePurposeStringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function DatasourcePurposeFromJSON(json: any): DatasourcePurpose {
    return DatasourcePurposeFromJSONTyped(json, false);
}
export function DatasourcePurposeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasourcePurpose {
    return json as DatasourcePurpose;
}
export function DatasourcePurposeToJSON(value?: DatasourcePurpose | null): any {
    return value as any;
}
